import { AccessibleIcon as AccessibleIconPrimitive } from 'radix-ui';
export const AccessibleIcon = AccessibleIconPrimitive.Root;
export type AccessibleIconProps = AccessibleIconPrimitive.AccessibleIconProps;
